import React from 'react'
import { connect } from 'react-redux'
import {
  ViewTitle,
  SimpleShowLayout,
  SimpleForm,
  SelectInput,
  Toolbar,
  SaveButton,
} from 'admin-on-rest'
import { CourseView } from '../components/CourseView'
import { joinCourse } from '../reducers'
import { Card, CardTitle } from 'material-ui/Card'

const CourseJoinToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <SaveButton label="courses.buttons.join" />
    </Toolbar>
  )
}

class StudentCoursePageJoin extends React.Component {
  render() {
    const { course } = this.props

    return (
      <div>
        <ViewTitle
          title={`Formular inscriere pentru cursul '${course.name}'`}
        />
        <SimpleShowLayout record={course}>
          <CourseView />
        </SimpleShowLayout>
        {course.students && Object.keys(course.students).length >= (course.availableSpots || 80) ? (
          <Card>
            <CardTitle>Momentan nu mai exista locuri disponibile</CardTitle>
          </Card>
        ) : (
          <SimpleForm
            toolbar={<CourseJoinToolbar />}
            save={(data) => {
              this.props.joinCourse(course.id)
            }}
          >
            {course.cost > 0 && (
              <div style={{ marginTop: 30 }}>
                <div>
                  Pentru inscrierea la acest curs, va rugam sa aveti in vedere
                  faptul ca va trebui sa achitati taxa de inscriere la orice
                  sucursala BRD.
                </div>
                <div>
                  Contul in care se va face plata este{' '}
                  <strong>RO26 BRDE 360S V983 9117 3600</strong>
                </div>
                <br />
              </div>
            )}
            {false && course.cost > 0 && (
              <SelectInput
                label="Modalitate de plata"
                source="paymentMethod"
                choices={[
                  { id: 'CARD', name: 'Plata online cu cardul' },
                  { id: 'DEPOSIT', name: 'Depunere numerar la ghiseu bancar' },
                ]}
              />
            )}
          </SimpleForm>
        )}
      </div>
    )
  }
}

export default connect(null, { joinCourse })(StudentCoursePageJoin)



// WEBPACK FOOTER //
// ./src/students/StudentCoursePageJoin.js